import {TableauPrix} from "@/components/Tableau/interface";
import {TarifFournisseur} from "@/ts/interface/detailOffre";

export function formatTarifFournisseur(
  tarifs: TarifFournisseur[],
): TableauPrix[] {
  const formatedTarif = tarifs.map(tarif => {
    return {firstCell: tarif.quantite, celules: [tarif.valeur]};
  });
  return formatedTarif;
}
